import React, { useEffect, useRef, useState } from 'react';
import { TextField, Link } from '@material-ui/core';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  TherapeucticHeader,
  TherapeuticRows,
  DrugFamilyDetailsHeader,
  DrugFamilyDetailsRows,
} from './TableHeader';
import TableComponent from './TableComponent';
import Grid from '../../../../SharedModules/Table/tableGrid.js';
import { getNDCDetails } from '../store/action';
import { setCurrentNDCDetailsSelected } from '../../../Display/NDC/store/action';
import {
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

const ViewDrugDetails = ({ assignDate, selectedNdcs }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const childRef = useRef(null);
  const [drugList, setDrugList] = React.useState([
    { type: 'input', label: 'NDC', value: 'ndc', column: 4, key: 'ndc' },
    {
      type: 'input',
      label: 'Drug Name',
      value: 'drug name',
      column: 4,
      key: 'drugName',
    },
    {
      type: 'input',
      label: 'Generic Code',
      value: 'g-code',
      column: 4,
      key: 'genericCodeNumber',
    },
    {
      type: 'input',
      label: 'Drug Generic Name',
      value: 'g-nmae',
      column: 4,
      key: 'drugGenericName',
    },
    {
      type: 'input',
      label: 'GCN',
      value: 'ndc',
      column: 4,
      key: 'gcnSequenceNumber',
    },
    {
      type: 'input',
      label: 'Dosage Form',
      value: 'dosage',
      column: 4,
      key: 'dosageFormDescr',
    },
    {
      type: 'input',
      label: 'Route of Administration',
      value: 'route',
      column: 4,
      key: 'drugRouteCd',
    },
    {
      type: 'table',
      label: 'Therapeutic Class',
      value: '',
      column: 12,
      header: TherapeucticHeader,
      rowData: TherapeuticRows,
      key: '',
    },
  ]);

  const [drugFamilyDetails, setDrugFamilyDetails] = React.useState([
    {
      type: 'input',
      label: 'Family Name',
      value: 'name',
      column: 4,
      key: 'familyName',
    },
    {
      type: 'input',
      label: 'Family Description',
      value: 'family des',
      column: 4,
      key: 'familyDescr',
    },
    {
      type: 'input',
      label: 'Brand Name',
      value: ' ',
      column: 4,
      key: 'brandName',
    },
    {
      type: 'input',
      label: 'Specific Therapeutic Class',
      value: ' ',
      column: 4,
      key: 'specificTheraClass',
    },
    {
      type: 'input',
      label: 'Manufacturer',
      value: ' ',
      column: 4,
      key: 'mfgId',
    },
    {
      type: 'input',
      label: 'WAC Override Percent',
      value: ' ',
      column: 4,
      key: 'wacPct',
    },
    {
      type: 'table',
      label: '',
      value: '',
      column: 12,
      header: DrugFamilyDetailsHeader,
      rowData: DrugFamilyDetailsRows,
      key: '',
    },
  ]);

  const [ndcValue, setNdcValue] = React.useState({
    drugName: '',
    ndc: '',
    dosageFormDescr: '',
    gcnSequenceNumber: '',
    genericCodeNumber: '',
    drugRouteCd: '',
    drugGenericName: '',
  });

  const { getDrugDetailsByid, selectedNdc, viewDrugModalDetail } = useSelector(
    (state) => state.sharedState.LinkNewDrugsReducer
  );

  const [refresh, setRefresh] = React.useState(true);
  const getNdcData = async (cellInfo) => {
    const response = await getNDCDetails([cellInfo]);
    const { labelerCode, productCode, packageSize, drugName } =
      response?.data[0];
    const {
      dosageFormDescr,
      drugGenericName,
      gcnSequenceNumber,
      genericCodeNumber,
      drugRouteCd,
    } = response?.data[0]?.drugDetailVOs;

    const ndc = `${labelerCode}-${productCode}-${packageSize}`;
    setNdcValue((prev) => ({
      ...prev,
      drugName: drugName,
      ndc: ndc,
      dosageFormDescr: dosageFormDescr,
      drugGenericName: drugGenericName,
      gcnSequenceNumber: gcnSequenceNumber,
      genericCodeNumber: genericCodeNumber,
      drugRouteCd: drugRouteCd,
    }));
    setRefresh(false);
  };

  React.useEffect(() => {
    if (selectedNdc && refresh) {
      getNdcData(selectedNdc);
    }
  }, [selectedNdc, refresh]);

  React.useEffect(() => {
    const obj1 = {};
    const obj2 = {};
    if (getDrugDetailsByid?.message === 'SUCESS' && viewDrugModalDetail) {
      const { shortDescription, specificTheraClass } =
        viewDrugModalDetail?.drugFamilyVO;
      const keyVal = Object.keys(ndcValue);

      drugList.map((val, index) => {
        if (val.type === 'input' && keyVal.includes(val.key)) {
          drugList[index].value = ndcValue[val.key];
        }

        if (val.type === 'table') {
          obj1.classCd = specificTheraClass || '';
          obj1.description = shortDescription || '';
          drugList[index].rowData = [obj1];
        }
      });

      const { drugFamilyVO, drugFamilyDrugVO } = viewDrugModalDetail;

      const keyVal1 = Object.keys(drugFamilyVO);
      drugFamilyDetails.map((val, index) => {
        if (keyVal1.includes(val.key)) {
          drugFamilyDetails[index].value = drugFamilyVO[val.key];
        }

        if (val.type === 'table') {
          const array = [];
          drugFamilyDrugVO.map((val) => {
            array.push({
              drugName: val?.drugName,
              ndc: val?.ndc,
              startDate: val?.startDt,
              endDate: val?.endDt,
            });
          });

          drugFamilyDetails[index].rowData = array;
        }
      });
    }

    setDrugList((prev) => [...prev]);
    setDrugFamilyDetails((prev) => [...prev]);
  }, [getDrugDetailsByid, viewDrugModalDetail, ndcValue]);

  // Get NDC Details
  const getNdcDetails = async (cellInfo) => {
    const { drugName, ndc } = cellInfo?.data;
    const response = await getNDCDetails([
      {
        ndc: ndc,
        drugName: drugName,
      },
    ]);

    if (response.message === 'SUCESS') {
      dispatch(setCurrentNDCDetailsSelected(response?.data[0],"All"));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  return (
    <div className="tabs-container" data-testid="ViewDrugDetails">
      <div className="row mb-2">
        <fieldset className="col-12 custom-fieldset mb-2">
          <legend>Drug Details</legend>
          <div className="row">
            {drugList.map((data) => (
              <>
                {data.type === 'table' ? (
                  <div className={`col-${data.column}`}>
                    <div className="row">
                      <div className="col-4">{data.label}</div>
                      <div className="col-8 panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-drug_section frr-white-background">
                        <TableComponent
                          searchByDrugNameTableData={data.rowData}
                          columnName={data.header}
                          fileName="Drug Details"
                          exportFile
                          gridHeight={150}
                          childPopup
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`col-${data.column} mb-2`}>
                    <TextField
                      data-testid="manufacturer-name-textField"
                      id={data.label}
                      className
                      disabled
                      label={data.label}
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 6 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={data.value}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        </fieldset>
        <fieldset className="col-12 custom-fieldset mb-2">
          <legend>Drug Family Details</legend>
          <div className="row">
            {drugFamilyDetails.map((data) => (
              <>
                {data.type === 'table' ? (
                  <div
                    className={`col-${data.column} panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-drug_section frr-white-background`}
                  >
                    <TableComponent
                      searchByDrugNameTableData={data.rowData}
                      columnName={data.header}
                      exportFile
                      data-testid="DrugFamilyDetails"
                      fileName="Drug Family Details"
                      gridHeight={160}
                      childPopup
                      frameworkComponents={{
                        startDateCell: (cellInfo) => {
                          return (
                            <div className="mui-custom-form mt-lg-n4 pt-1  input-md">
                              <TextField
                                data-testid="manufacturer-name-textField"
                                id="StartDate"
                                className="customInputData"
                                label=" "
                                disabled
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 6, id: 'StartDate' }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={cellInfo.data.startDate}
                              />
                            </div>
                          );
                        },
                        endDateCell: (cellInfo) => {
                          return (
                            <div className="mui-custom-form mt-lg-n4 pt-1  input-md">
                              <TextField
                                data-testid="manufacturer-name-textField"
                                id="endDate"
                                className="customInputData"
                                label=" "
                                disabled
                                fullWidth
                                placeholder=""
                                inputProps={{ maxLength: 6, id: 'StartDate' }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={cellInfo.data.endDate}
                              />
                            </div>
                          );
                        },
                        LinkNdcButton: (cellInfo) => {
                          return (
                            <a href="#" onClick={() => getNdcDetails(cellInfo)}>
                              {cellInfo && cellInfo.data.ndc}
                            </a>
                          );
                        },
                        DrugNameRenderer: (cellInfo) => {
                          if (
                            cellInfo.data.drugName !== null &&
                            cellInfo.data.drugName !== '' &&
                            cellInfo.data.drugName.length > 17
                          ) {
                            return (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="labeler-tooltip">
                                    {cellInfo.data.drugName}
                                  </Tooltip>
                                }
                              >
                                <div>
                                  {cellInfo.data.drugName &&
                                    `${cellInfo.data.drugName.substring(
                                      0,
                                      13
                                    )}...`}
                                </div>
                              </OverlayTrigger>
                            );
                          }
                          return <div>{cellInfo.value}</div>;
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div className={`col-${data.column} mb-2`}>
                    <TextField
                      data-testid="manufacturer-name-textField"
                      id={data.label}
                      className
                      disabled
                      label={data.label}
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 6 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={data.value}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default ViewDrugDetails;
